// 合同管理
export default {
  path: '/contract',
  component: () => import('@/layout/Empty.vue'),
  redirect: '/contract/list',
  children: [
    {
      path: 'list',
      name: 'contractList',
      redirect: 'list/wfm',
      component: () => import('@/views/user/contract/contractList/ContractListMain.vue'),
      meta: {
        title: '签约管理'
      },
      children: ['all', 'wfm', 'wfo', 'done', 'draft', 'cancel', 'reject', 'overdue', 'rejectFilled'].map(tab => {
        const pascalCaseName = tab.charAt(0).toUpperCase() + tab.slice(1)
        return {
          path: tab,
          name: 'contractList' + pascalCaseName,
          component: () => import(`@/views/user/contract/contractList/ContractList${pascalCaseName}.js`)
        }
      })
    },
    {
      path: 'detail/:id',
      name: 'contractDetail',
      component: () => import('@/views/user/contract/ContractDetail.vue'),
      props: true,
      meta: {
        title: '合同详情',
        layout: {
          pageBack: true
        }
      }
    },
    {
      path: 'fill/:id',
      name: 'contractFill',
      component: () => import('@/views/user/contract/ContractFill'),
      props: true,
      meta: {
        title: '合同填写',
        layout: {
          subPage: true,
          pageWrap: false
        },
        personVerify: true,
        companyVerify: true
      }
    },
    {
      path: 'preview/:id',
      name: 'contractPreview',
      component: () => import('@/views/user/contract/ContractPreview.vue'),
      props: true,
      meta: {
        title: '合同预览',
        layout: {
          subPage: true,
          pageWrap: false
        }
      }
    },
    {
      path: 'replenish/:id/:contractId',
      name: 'contractReplenish',
      component: () => import('@/views/user/contract/ContractPreview.vue'),
      props: true,
      meta: {
        title: '合同预览',
        layout: {
          subPage: true,
          pageWrap: false
        }
      }
    },
    {
      path: 'batchSigning/select',
      name: 'batchSigningSelect',
      component: () => import('@/views/user/contract/BatchSigningSelect.vue'),
      props: true,
      meta: {
        title: '批量签署',
        layout: {
          subPage: true
        }
      }
    }
  ]
}
